// extracted by mini-css-extract-plugin
module.exports = {"likeBtn":"LikeButton_likeBtn__1uwbU","likeAnimation":"LikeButton_likeAnimation__xAqHk","unlikeAnimation":"LikeButton_unlikeAnimation__Y4ele"};